// Orden de las contrapartes del clasificador. Lógica pura extraída de
// DashboardClassificator (sin estado de Vue): recibe sortColumn/sortDirection
// como parámetros y devuelve el arreglo ordenado.

const ORDER_PLAN_MAP = {
    Ventas: 0,
    Costos: 1,
    Gastos: 2,
    "No Operacional": 3,
    Activos: 4,
};

export function findLowestLevel1(list, isMotherAccount = false) {
    let min = 99999;
    for (const elem of list) {
        const val = isMotherAccount ? elem : elem["level_1"];
        const io = ORDER_PLAN_MAP[val] !== undefined ? ORDER_PLAN_MAP[val] : -1;
        if (io >= 0 && io < min) {
            min = io;
        }
        if (min === 0) {
            break;
        }
    }
    return min;
}

export function compareEntries(a, b, sortColumn, sortDirection, subtype) {
    const pos = sortColumn.indexOf("attribute_");
    let col_name = sortColumn;
    if (pos == 0) {
        col_name = "attribute";
    }
    const valA = a[col_name];
    const valB = b[col_name];
    if (col_name == "accounts") {
        const la = valA.length;
        const lb = valB.length;
        if (la == 0 || lb == 0) {
            return sortDirection === "asc" ? la - lb : lb - la;
        }
        const lowestA = findLowestLevel1(valA);
        const lowestB = findLowestLevel1(valB);
        if (lowestA == lowestB) {
            const subOrderA = valA[0].level_3;
            const subOrderB = valB[0].level_3;
            const diff = subOrderA.localeCompare(subOrderB);
            return sortDirection === "asc" ? diff : -diff;
        }
        return sortDirection === "asc" ? lowestA - lowestB : lowestB - lowestA;
    } else if (col_name == "mother_accounts") {
        const la = valA.length;
        const lb = valB.length;
        if (la == 0 || lb == 0) {
            return sortDirection === "asc" ? la - lb : lb - la;
        }
        const lowestA = findLowestLevel1(valA, true);
        const lowestB = findLowestLevel1(valB, true);
        if (lowestA == lowestB) {
            const subOrderA = a["total_3_months"];
            const subOrderB = b["total_3_months"];
            return subOrderB - subOrderA;
        }
        return sortDirection === "asc" ? lowestA - lowestB : lowestB - lowestA;
    } else if (col_name == "attribute") {
        if (!valA[subtype] && !valB[subtype]) {
            const subOrderA = a["total_3_months"];
            const subOrderB = b["total_3_months"];
            return subOrderB - subOrderA;
        } else if (valA[subtype] && !valB[subtype]) {
            return 1;
        } else if (!valA[subtype] && valB[subtype]) {
            return -1;
        }
        let totalA = valA[subtype][0]["name"],
            totalB = valB[subtype][0]["name"];
        if (totalA == totalB) {
            const subOrderA = a["total_3_months"];
            const subOrderB = b["total_3_months"];
            return subOrderB - subOrderA;
        }
        const total_diff = totalA.localeCompare(totalB);
        return sortDirection === "asc" ? total_diff : -total_diff;
    } else {
        let compare = 0;
        if (
            (typeof valA === "boolean" && typeof valB === "boolean") ||
            (typeof valA === "number" && typeof valB === "number")
        ) {
            compare = valA - valB;
        } else {
            compare = valA.localeCompare(valB);
        }
        if (compare == 0) {
            const subOrderA = a["total_3_months"];
            const subOrderB = b["total_3_months"];
            return subOrderB - subOrderA;
        }
        return sortDirection === "asc" ? compare : -compare;
    }
}

// Ubica las contrapartes no clasificadas primero, y ordena cada grupo por la
// columna/dirección dadas. Devuelve un nuevo arreglo (no muta la entrada).
export function sortCounterparts(entries, sortColumn, sortDirection, subtype = null) {
    const classified = [];
    const notClassified = [];
    for (const entry of entries) {
        if (
            (entry.accounts && entry.accounts.length > 0) ||
            entry.classify_by_counterpart != "Sin Clasificar"
        ) {
            classified.push(entry);
        } else {
            notClassified.push(entry);
        }
    }
    const cmp = (a, b) => compareEntries(a, b, sortColumn, sortDirection, subtype);
    classified.sort(cmp);
    notClassified.sort(cmp);
    return [...notClassified, ...classified];
}
